import { DataBean } from "../DataBean";

export class EmploymentType extends DataBean {


    public async getEmploymentTypeCatalog(id:any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getEmploymentTypeCatalog_Number", [id]);
    }

    

 
}